import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import TwoLevelRadio from '@Pages/ProfileSettings/Preferences/components/TwoLevelRadio';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';
import './SearchStructure.scss';

function SearchStructure({ title, options, currentOption, onChange, onSave, onClose }) {
  const handleChange = (value) => {
    onChange(null, value);
  };

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.searchStructure}
      title={title}
      value={title}
      validateOnSave
      className="search-structure-accordion-item">
      {options.map((option) => {
        const key = `${option.name}-${option.value}`;
        return (
          <div key={key} className="search-drawing clearfix">
            {option.type === 'radio' &&
              (option.subOptions ? (
                <TwoLevelRadio option={option} value={currentOption} onChange={handleChange} />
              ) : (
                <RadioButtonGroup.Option
                  id={key}
                  className="search-structure__radio-option"
                  name={option.name}
                  label={option.title}
                  value={option.value}
                  disabled={option.disabled}
                  checked={currentOption === option.value} // Compare currentOption with the value
                  onChange={() => handleChange(option.value)} // Pass the selected value to handleChange
                  aria-label={`Search this structure ${option.title.toLowerCase()}`}
                />
              ))}
          </div>
        );
      })}
    </ProfileSettingsAccordionItem>
  );
}

SearchStructure.propTypes = {
  currentOption: PropTypes.string,
  options: PropTypes.array,
  title: PropTypes.string,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

SearchStructure.defaultProps = {
  options: [],
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default SearchStructure;
